// extracted by mini-css-extract-plugin
export default {"container":"EditorUploader_container__wcjjp","button":"EditorUploader_button__2UQId"};